import React from 'react';
import PropTypes from 'prop-types';
import {
  NewsletterArticle,
  NewsletterHeader,
  NewsletterMonth,
  NewsletterTitle,
  NewsletterExcerpt,
  NewsletterSections,
  NewsletterSection,
  SectionTitle,
  NewsletterBody,
  Empty,
} from './News.styles';

const SelectedNewsletter = ({ selected }) => {
  if (!selected) {
    return <Empty>Select a newsletter to view its content.</Empty>;
  }

  const hasNewSections =
    Array.isArray(selected.sections) && selected.sections.length > 0;

  // normalize links: Mongoose Map will be serialized as an object, but handle Map just in case
  const linksEntries = [];
  if (selected.links) {
    if (selected.links instanceof Map) {
      for (const [k, v] of selected.links.entries()) {
        linksEntries.push([k, v]);
      }
    } else if (typeof selected.links === 'object') {
      for (const k of Object.keys(selected.links)) {
        linksEntries.push([k, selected.links[k]]);
      }
    }
  }

  const LinksBlock = () => {
    if (!linksEntries.length) return null;
    return (
      <div style={{ margin: '0 0 16px 0' }}>
        <h4 style={{ margin: '0 0 8px 0' }}>Links</h4>
        <ul style={{ margin: 0, paddingLeft: '1rem' }}>
          {linksEntries.map(([label, url]) => (
            <li key={label}>
              <a href={url} target="_blank" rel="noopener noreferrer">
                {label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  };
  return (
    <NewsletterArticle>
      <NewsletterHeader>
        {selected?.month && <NewsletterMonth>{selected.month}</NewsletterMonth>}

        {selected?.newsletterTitle && (
          <NewsletterTitle>{selected.newsletterTitle}</NewsletterTitle>
        )}

        {selected?.excerpt && (
          <NewsletterExcerpt>{selected.excerpt}</NewsletterExcerpt>
        )}
      </NewsletterHeader>
      <NewsletterSections>
        {hasNewSections ? (
          selected.sections.map((section, index) => (
            <NewsletterSection key={`${section?.title || 'section'}-${index}`}>
              {section?.title && <SectionTitle>{section.title}</SectionTitle>}

              {/* Render block-based content if present */}
              {Array.isArray(section.blocks) && section.blocks.length > 0
                ? section.blocks.map((block, bi) => {
                    if (!block) return null;
                    if (block.type === 'paragraph' || block.type === 'html') {
                      return (
                        <NewsletterBody
                          key={`block-${bi}`}
                          dangerouslySetInnerHTML={{ __html: block.text || '' }}
                        />
                      );
                    }

                    if (block.type === 'list') {
                      return (
                        <ul key={`block-${bi}`}>
                          {(block.items || []).map((it, ii) => (
                            <li key={ii}>{it}</li>
                          ))}
                        </ul>
                      );
                    }

                    if (block.type === 'link') {
                      return (
                        <p key={`block-${bi}`}>
                          <a
                            href={block.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {block.text || block.url}
                          </a>
                        </p>
                      );
                    }

                    return null;
                  })
                : // Fallback to legacy single-string content
                  section?.content && (
                    <NewsletterBody
                      dangerouslySetInnerHTML={{
                        __html: section.content,
                      }}
                    />
                  )}
            </NewsletterSection>
          ))
        ) : (
          <>
            {selected?.title1 && (
              <NewsletterSection>
                <SectionTitle>{selected.title1}</SectionTitle>

                {selected?.content1 && (
                  <NewsletterBody
                    dangerouslySetInnerHTML={{
                      __html: selected.content1,
                    }}
                  />
                )}
              </NewsletterSection>
            )}

            {selected?.title2 && (
              <NewsletterSection>
                <SectionTitle>{selected.title2}</SectionTitle>

                {selected?.content2 && (
                  <NewsletterBody
                    dangerouslySetInnerHTML={{
                      __html: selected.content2,
                    }}
                  />
                )}
              </NewsletterSection>
            )}

            {selected?.title3 && (
              <NewsletterSection>
                <SectionTitle>{selected.title3}</SectionTitle>

                {selected?.content3 && (
                  <NewsletterBody
                    dangerouslySetInnerHTML={{
                      __html: selected.content3,
                    }}
                  />
                )}
              </NewsletterSection>
            )}
          </>
        )}
      </NewsletterSections>
      <LinksBlock />
    </NewsletterArticle>
  );
};

SelectedNewsletter.propTypes = {
  selected: PropTypes.object,
};

export default SelectedNewsletter;
